import { Provider } from '@angular/core';

import { CertificatesUseCasesImpl } from '@app/domain/use-cases/ptrab/certificates/certificates.use-cases';
import { CERTIFICATES_USE_CASES } from '@app/domain/use-cases/ptrab/certificates/certificates.use-cases.contract';

export const certificatesUseCasesProvider: Provider = {
  provide: CERTIFICATES_USE_CASES,
  useClass: CertificatesUseCasesImpl
};
